export const PAYMENT_METHOD_CODES = {
  CASH: '01',
  DEBIT_CARD: '02',
  CREDIT_CARD: '03',
  CHECK: '04',
  TRANSFER: '05',
  ELECTRONIC_MONEY: '08',
  EWALLET: '09',
  BITCOIN: '11',
  CRYPTO: '12',
  ACCOUNTS_RECEIVABLE: '13',
  BANK_DRAFT: '14',
  OTHER: '99',
} as const;

export const mapPayments = (payments: any[] = []) => {
  return payments.map((p) => {

    const isCash = p.paymentMethodCode === PAYMENT_METHOD_CODES.CASH;

    return {
      paymentMethodCode: p.paymentMethodCode,

      amount: Number(p.amount) || 0,

      cashReceived: isCash
        ? p.cashReceived !== '' && p.cashReceived !== undefined
          ? Number(p.cashReceived)
          : null
        : null,

      changeAmount: isCash
        ? Number(p.changeAmount) || 0
        : 0,

      reference: !isCash
        ? p.reference || null
        : null,
    };

  });
};